import { searchLocation as searchLocationRepo } from '../../../data/repositories/locationRepository.js';

export const searchLocation = (query) => searchLocationRepo(query);
